import { ReactComponent as FloatBtnSVG } from "./float-btn.svg";
import { SvgIcon } from '@mui/material';

export default function IconFloatBtnEN(props) {
  return <SvgIcon {...props} component={FloatBtnSVG} viewBox="0 0 72 72" />;
}